// extracted by mini-css-extract-plugin
export default {"article":"Article_article__MjEo1"};